import { useRouter } from 'next/router'
import GradientButton from '../Buttons/GradientButton'
import { ContainerWrapper } from '../Container'
import NewSecondaryButton from '../Buttons/NewSecondaryButton'
import SectionHeading from './SectionHeading'
import SectionSubText from './SectionSubText'
import W1Icon from '../../Icons/realEsatePostcards/w1.svg'
import W2Icon from '../../Icons/realEsatePostcards/w2.svg'
import W3Icon from '../../Icons/realEsatePostcards/w3.svg'
import W4Icon from '../../Icons/realEsatePostcards/w4.svg'

const RocketIcon = () => <W1Icon className='width="28" height="28"' />

const TargetIcon = () => <W2Icon className='width="28" height="28"' />

const LaunchIcon = () => <W3Icon className='width="28" height="28"' />

const ListIcon = () => <W4Icon className='width="28" height="28"' />

const steps = [
    {
        number: 1,
        title: 'Pick Your Design',
        description: 'Choose from tested, high-converting templates',
        Icon: RocketIcon,
    },
    {
        number: 2,
        title: 'Target Your List',
        description: 'Build custom lists with our advanced tools',
        Icon: TargetIcon,
    },
    {
        number: 3,
        title: 'Launch Campaign',
        description: 'We print, stamp, and mail for you',
        Icon: LaunchIcon,
    },
    {
        number: 4,
        title: 'Track Results',
        description: 'Review performance analytics and optimize ROI',
        Icon: ListIcon,
    },
]

function Step({ number, title, description, Icon }) {
    return (
        <div className="flex flex-col items-center text-center w-full">
            <div className="relative">
                {/* badge */}
                <span className="absolute -top-2 -left-2 text-[12px] font-semibold text-[#f05a2b] bg-[#ffe9dc] px-2 py-[2px] rounded-full shadow-sm">
                    {number}
                </span>
                {/* icon circle */}
                <div className="w-20 h-20 md:w-20 md:h-20 rounded-full bg-[#f05a2b] flex items-center justify-center shadow-[0_10px_24px_rgba(255,101,47,0.18)]">
                    <Icon />
                </div>
            </div>

            <h3 className="mt-6 text-xl font-semibold text-olm-black">
                {title}
            </h3>
            <p className="mt-2 text-olm-new-black max-w-[250px] leading-relaxed">
                {description}
            </p>
        </div>
    )
}

export default function HowItWorks({
    heading = 'How It Works',
    subheading = 'Getting started with postcards is simple:',
    primaryCta = { label: 'Start My Campaign', href: '/products' },
    secondaryCta = { label: 'Get Expert Marketing Support', href: '#' },
}) {
    const router = useRouter()

    return (
        <section aria-labelledby="how-it-works-heading" className="py-16">
            <ContainerWrapper>
                <SectionHeading>{heading}</SectionHeading>
                <SectionSubText>{subheading}</SectionSubText>

                {/* Steps with connectors on md+ */}
                <div className="w-full max-w-6xl px-2 py-5 mt-8 mx-auto">
                    <div className="flex flex-col md:flex-row items-center md:justify-between gap-10 md:gap-6">
                        {steps.map((s, idx) => (
                            <div
                                key={s.number}
                                className="flex items-center w-full md:w-auto relative">
                                <Step {...s} />
                                {/* connector line except after the last item (md+) */}
                                {idx < steps.length - 1 && (
                                    <div className="hidden md:block h-[2px] bg-[#ffd9c1] w-16 md:w-[calc(100%-70px)] mx-4 shrink-0 absolute left-[calc(50%+40px)] top-[calc(50%-50px)]" />
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* CTAs */}
                <div className="mt-12 md:mt-16 flex flex-col sm:flex-row items-center justify-center gap-4 max-w-3xl mx-auto">
                    <div className="max-w-[280px] w-full">
                        <GradientButton
                            onClick={() => {
                                router.push(primaryCta?.href)
                            }}>
                            {primaryCta?.label}
                        </GradientButton>
                    </div>
                    <div className="max-w-[350px] w-full">
                        <NewSecondaryButton
                            onClick={() => {
                                router.push(secondaryCta?.href)
                            }}>
                            {secondaryCta?.label}
                        </NewSecondaryButton>
                    </div>
                </div>
            </ContainerWrapper>
        </section>
    )
}
